import React from "react";
import { useSelector } from "react-redux";
import { HashRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute";

// Scenes
import {
  Layout,
  Dashboard,
  Products,
  Customers,
  Transactions,
  Geography,
  Overview,
  Daily,
  Monthly,
  Breakdown,
  Admin,
  Performance,
  LoginPage,
  Categories,
  Questions,
  Notifications,
  WithdrawRequests,
  Settings,
  AdsSettings,
  LeaderboardStreakSettings,
  ReferralMessageSettings,
  PrizeLeaderboard,
  PrizeLeaderboardLive,
  PrizeLeaderboardLiveMobile,
  ListedLeaderboards,
} from "scenes";

// App
const App = () => {
  // Dark/Light mode
  const mode = useSelector((state) => state.global.mode);

  // Force HTTP redirect if on HTTPS
  React.useEffect(() => {
    if (window.location.protocol === 'https:') {
      const httpUrl = window.location.href.replace('https:', 'http:');
      window.location.replace(httpUrl);
    }
  }, []);

  return (
    <div className={`app ${mode === 'dark' ? 'dark' : ''}`}>
      <HashRouter>
        <Routes>
           {/* Routes without layout */}
          <Route path="/" element={<LoginPage />} />
       
       
          <Route element={<PrivateRoute />}>
            <Route
              path="/prize-leaderboard/live/:productId/:playToken"
              element={<PrizeLeaderboardLive />}
            />
            <Route
              path="/prize-leaderboard/live-mobile/:productId/:playToken"
              element={<PrizeLeaderboardLiveMobile />}
            />
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/category" element={<Categories />} />
              <Route path="/products" element={<Products />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/geography" element={<Geography />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/daily" element={<Daily />} />
              <Route path="/monthly" element={<Monthly />} />
              <Route path="/breakdown" element={<Breakdown />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/questions" element={<Questions />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/withdraw-requests" element={<WithdrawRequests />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/ads-settings" element={<AdsSettings />} />
              <Route
                path="/leaderboard-streak"
                element={<LeaderboardStreakSettings />}
              />
              <Route
                path="/referral-message"
                element={<ReferralMessageSettings />}
              />
              <Route path="/prize-leaderboard" element={<PrizeLeaderboard />} />
              <Route
                path="/listed-leaderboards"
                element={<ListedLeaderboards />}
              />
            </Route>
          </Route>
        </Routes>
      </HashRouter>
    </div>
  );
};

export default App;
